import React, {useState} from 'react'
import styles from './styles.module.scss'
import {Autocomplete, Button, Input} from "../../../ui-components";
import {useAppDispatch, useAppSelector} from "../../../core/hooks";
import TimePicker from "react-time-picker/dist/esm";
import moment from "moment";
import {addDestinationCustomer} from "../../requests/er-thunk";
import {Datepicker} from "../../../shared";
import {CUSTOMERSREGIONS} from "../../../services/constants";



const AddDestinationForm = () => {
  const currentDate = new Date();
  const isEditable = false
  const dispatch = useAppDispatch()
  const [updateData, setUpdateData] = useState({
    arrival_date: new Date().toString(),
    time: moment(currentDate).format("HH:mm"),
    // waiting_time: moment(currentDate).format("HH:mm"),
    address: "",
    infoText: "",
    city: "",
  })
  return (
    <div id={styles.replaceBrigadeForm}>
      <div className={styles.container}>
        <div className={styles.body}>
          <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', gap: 16, display: 'inline-flex'}}>
            <Autocomplete className={styles.select}
                          options={CUSTOMERSREGIONS}
                          onChange={(val) =>  setUpdateData({...updateData, city: val?.type})}
                          optionLabel={'type'}
                          optionValue={'type'}
                          value={updateData.city}
                          // disabled/**/
                          error={!updateData.city}
                          label="Город"/>
            <Input name='address'
                   className={styles.input}
                   value={updateData?.address}
                   error={!updateData?.address}
                   disabled={isEditable}
                   onChange={(e) => setUpdateData({...updateData, address: e?.target?.value})}
                   label="Адрес"/>
            <Input name='infoText'
                   className={styles.input}
                   value={updateData?.infoText}
                   disabled={isEditable}
                   onChange={(e) => setUpdateData({...updateData, infoText: e?.target?.value})}
                   label="Доп. информация"/>
          </div>
          <div className={styles.bodyHeadWrapper} >
            <Datepicker error={!updateData.arrival_date}
                        disableDates={new Date().toString()}
                        handleDateChange={(date) => setUpdateData({...updateData, arrival_date: date})}
                        value={updateData.arrival_date || new Date().toString()} label={"Дата прибытия"}/>
            <div style={{width: "100%",  paddingBottom: 4, borderBottom: '1px #BDC1CC solid', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 2, display: 'inline-flex'}}>
              <div style={{    position: "relative",
                marginTop: -20, alignSelf: 'stretch', color: '#505D66', fontSize: 12,  fontWeight: 500,  wordWrap: 'break-word'}}>Время прибытия</div>
              <TimePicker disabled={isEditable}  className={[styles.timePicker]} required clearIcon secondPlaceholder={"Time"} format={"H:mm"} disableClock  onChange={(e) => setUpdateData({...updateData, time: e})} value={updateData?.time} />
            </div>
          </div>
          <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', gap: 16, display: 'inline-flex'}}>
            {/*<div style={{width: "100%",  paddingBottom: 4, borderBottom: '1px #BDC1CC solid', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 2, display: 'inline-flex'}}>*/}
            {/*  <div style={{    position: "relative",*/}
            {/*    marginTop: -20, alignSelf: 'stretch', color: '#505D66', fontSize: 12,  fontWeight: 500,  wordWrap: 'break-word'}}>Ожидание на месте</div>*/}
            {/*  <TimePicker disabled={isEditable}  className={[styles.timePicker]} required clearIcon secondPlaceholder={"Time"} format={"H:mm"} disableClock  onChange={(e) => setUpdateData({...updateData, waiting_time: e})} value={updateData?.waiting_time} />*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
      <Button fullWidth
              onClick={() => dispatch(addDestinationCustomer(updateData))}
              type={'contained'}>Добавить пункт назначения</Button>
    </div>
  )
}

export default AddDestinationForm
